<template>
    <div v-if="showDialog && product && images.length" class="us-modal-overlay" @click.self="closeModal">
        <div class="lm">
            <button type="button" class="lm__close" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>

            <div class="lm__scroll">
                <!-- Product Section -->
                <section class="lm__product">
                    <div class="lm__product-wrap">
                        <div class="lm__product-box">
                            <!-- Images -->
                            <div class="lm__images">
                                <div class="lm__slider">
                                    <div class="lm__slide-img">
                                        <img v-if="images.length" :src="images[slide]" :alt="name">
                                        <template v-if="images.length > 1">
                                            <button type="button" class="lm__arrow lm__arrow--l" @click="prevSlide">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                                            </button>
                                            <button type="button" class="lm__arrow lm__arrow--r" @click="nextSlide">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                                            </button>
                                        </template>
                                    </div>
                                    <div v-if="images.length > 1" class="lm__thumbs">
                                        <button v-for="(img, i) in images" :key="i" type="button" class="lm__thumb" :class="{ 'lm__thumb--active': slide === i }" @click="slide = i">
                                            <img :src="img" :alt="`${name} ${i + 1}`">
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Detail -->
                            <div class="lm__detail">
                                <div v-if="categoryLabel" class="lm__category-label">{{ categoryLabel }}</div>

                                <div class="lm__rating">
                                    <div class="lm__stars">
                                        <svg v-for="i in 5" :key="i" viewBox="0 0 20 20" width="18" height="18"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" fill="#ffdf01" /></svg>
                                    </div>
                                    <div class="lm__trustpilot-rating">
                                        <span class="lm__tp-excellent">Excellent</span>
                                        <span class="lm__tp-score">4.6 out of 5</span>
                                    </div>
                                </div>

                                <div class="lm__name-box">
                                    <div class="lm__name">{{ name }}</div>
                                    <div v-if="form" class="lm__brand">{{ form }}</div>
                                </div>

                                <div class="lm__divider"></div>

                                <div v-if="headline" class="lm__desc-header">{{ headline }}</div>
                                <p v-if="description" class="lm__desc">{{ description }}</p>

                                <div v-if="bullets.length" class="lm__bullets">
                                    <div v-for="(b, i) in bullets" :key="i" class="lm__bullet">
                                        <svg viewBox="0 0 22 22" width="22" height="22" class="lm__bullet-icon"><circle cx="11" cy="11" r="10" fill="#e8ff86" stroke="#999" stroke-width="1" /><path d="M6.5 11.5l3 3L15.5 8" stroke="#000" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round" /></svg>
                                        <span>{{ b }}</span>
                                    </div>
                                </div>

                                <div class="lm__divider"></div>

                                <div class="lm__perks">
                                    <div class="lm__perk">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
                                        <span><strong>Overnight </strong>Shipping</span>
                                    </div>
                                    <div class="lm__perk">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="M9 12l2 2 4-4"></path></svg>
                                        <span><strong>Full Refund </strong>if Declined By Doctor</span>
                                    </div>
                                </div>

                                <div class="lm__payments">
                                    <img :src="paymentMethodsImg" alt="Payment Methods">
                                </div>

                                <div class="lm__arrival">
                                    <div class="lm__arrival-dot"></div>
                                    <span>Order today and get it by <strong v-html="futureDate"></strong></span>
                                </div>
                                <div class="lm__delivery-note">*Mon - Thursday Overnight Shipping (Not on Weekends)</div>

                                <div v-if="dropdowns.length" class="lm__dropdowns">
                                    <div v-for="(dd, i) in dropdowns" :key="i" class="lm__dropdown">
                                        <button type="button" class="lm__dropdown-toggle" @click="openDropdown = openDropdown === i ? null : i">
                                            <span>{{ dd.header }}</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lm__dropdown-chevron" :class="{ 'lm__dropdown-chevron--open': openDropdown === i }"><polyline points="6 9 12 15 18 9"></polyline></svg>
                                        </button>
                                        <div v-if="openDropdown === i" class="lm__dropdown-body">
                                            <p>{{ dd.text }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Why Choose (highlights — DB-driven, optional) -->
                <section v-if="highlights" class="lm__section">
                    <div class="lm__highlights-wrap">
                        <div class="lm__highlights-text">
                            <h3 class="lm__section-title">{{ highlights.heading || `Why Choose ${name}?` }}</h3>
                            <p v-if="highlights.description" class="lm__section-sub">{{ highlights.description }}</p>
                        </div>
                        <div class="lm__why-grid">
                            <div v-if="whyHasTop" class="lm__why-pill lm__why-pill--top">
                                <span v-html="whyTop"></span>
                            </div>
                            <div class="lm__why-middle">
                                <div class="lm__why-col">
                                    <div v-for="(t, i) in whyLeft" :key="`l-${i}`" class="lm__why-pill"><span v-html="t"></span></div>
                                </div>
                                <div v-if="whyImage" class="lm__why-image">
                                    <img :src="whyImage" :alt="name">
                                </div>
                                <div class="lm__why-col">
                                    <div v-for="(t, i) in whyRight" :key="`r-${i}`" class="lm__why-pill"><span v-html="t"></span></div>
                                </div>
                            </div>
                            <p v-if="highlights.disclaimer" class="lm__why-disclaimer">{{ highlights.disclaimer }}</p>
                        </div>
                    </div>
                </section>

                <!-- How It Works -->
                <section class="lm__section">
                    <h3 class="lm__section-title">How It Works</h3>
                    <p class="lm__section-sub">No Insurance Needed. All Online.</p>
                    <div class="lm__steps">
                        <div v-for="(step, i) in howItWorks" :key="i" class="lm__step">
                            <div class="lm__step-flex">
                                <div class="lm__step-img">
                                    <img :src="step.image" :alt="step.title">
                                </div>
                                <div class="lm__step-text">
                                    <div class="lm__step-title">{{ step.title }}</div>
                                    <div class="lm__step-desc">{{ step.desc }}</div>
                                </div>
                                <div class="lm__step-num">{{ i + 1 }}</div>
                            </div>
                            <div class="lm__step-badge">{{ step.badge }}</div>
                        </div>
                    </div>
                </section>

                <!-- Comparison -->
                <section class="lm__section lm__section--last">
                    <div class="lm__table-header">What sets <img :src="brandLogo" alt="NewSelf" class="lm__table-logo"> apart</div>
                    <div class="lm__compare">
                        <div class="lm__compare-head">
                            <div class="lm__compare-label"></div>
                            <div class="lm__compare-col"><img :src="brandLogo" alt="NewSelf" class="lm__compare-logo"></div>
                            <div class="lm__compare-col lm__compare-col--muted">Competition</div>
                        </div>
                        <div v-for="row in comparisonRows" :key="row" class="lm__compare-row">
                            <div class="lm__compare-label">{{ row }}</div>
                            <div class="lm__compare-col">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lm__icon--green"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                            </div>
                            <div class="lm__compare-col">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lm__icon--red"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { normalizeImageUrl } from './upsellAdapter';

export default {
    name: 'UpSellPageModal',
    props: {
        // DB products from /api/get-all-products
        apiProducts: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showDialog: false,
            currentId: '',
            slide: 0,
            openDropdown: null,
            futureDate: '',
            // Static brand chrome (same assets/copy the Next.js reference modal ships).
            paymentMethodsImg: require('@/assets/images/Payment_Methods.webp'),
            brandLogo: require('@/assets/images/dark-logo.webp'),
            howItWorks: [
                { title: 'Fill Out Short Quiz', desc: 'Get pre-qualified for free in 2 minutes.', badge: '5 mins', image: require('@/assets/images/WeightSteps_QuizFlip.webp') },
                { title: 'Meet with Tele-doc', desc: 'Board Certified Doctors on demand.', badge: 'Today', image: require('@/assets/images/WeightSteps_Teledoc.webp') },
                { title: 'Next Day Shipping', desc: 'Cold Packed & Ready to use medications.', badge: 'Cold Shipped', image: require('@/assets/images/WeightSteps_deliverscreen-p-800.webp') },
                { title: 'Ongoing Clinical Support', desc: 'AI support plus real nurses to guide your journey.', badge: '24/7 Support', image: require('@/assets/images/WeightSteps_Plan2.webp') }
            ],
            comparisonRows: [
                'Doctor Prescribed Revolutionary Therapies.',
                'Synergistic Supplements for the whole body.',
                'Access to network of nationwide pharmacies.',
                'A.I. Enabled Health Optimization Tools.',
                'Chat & Email Access to Clinical Resources.'
            ]
        }
    },
    computed: {
        product() {
            if (!this.currentId || !Array.isArray(this.apiProducts)) return null;
            return this.apiProducts.find(p => p && (p.id === this.currentId || p._id === this.currentId)) || null;
        },
        images() {
            if (!this.product || !Array.isArray(this.product.images)) return [];
            return this.product.images.map(i => normalizeImageUrl(i && i.url)).filter(Boolean);
        },
        name() {
            return this.product ? (this.product.name || '') : '';
        },
        categoryLabel() {
            return (this.product && this.product.category && this.product.category.primary) || '';
        },
        form() {
            if (!this.product) return '';
            return (this.product.marketing && this.product.marketing.product_format) || this.product.type || '';
        },
        headline() {
            return (this.product && this.product.marketing && this.product.marketing.sub_header) || '';
        },
        description() {
            return (this.product && this.product.marketing && this.product.marketing.description) || '';
        },
        bullets() {
            // product_bullets is an array (new contract) or a { bullet1..N } object (legacy) — handle both.
            const raw = this.product && this.product.product_bullets;
            if (Array.isArray(raw)) return raw.filter(Boolean);
            if (raw && typeof raw === 'object') return Object.values(raw).filter(Boolean);
            return [];
        },
        dropdowns() {
            return this.product && Array.isArray(this.product.dropdowns) ? this.product.dropdowns : [];
        },
        highlights() {
            return this.product && this.product.highlights ? this.product.highlights : null;
        },
        whyFeatures() {
            return this.highlights && Array.isArray(this.highlights.features) ? this.highlights.features : [];
        },
        whyHasTop() {
            return this.whyFeatures.length >= 5;
        },
        whyTop() {
            return this.whyHasTop ? this.whyFeatures[0] : '';
        },
        whyLeft() {
            const o = this.whyHasTop ? 1 : 0;
            return [this.whyFeatures[o], this.whyFeatures[o + 1]].filter(Boolean);
        },
        whyRight() {
            const o = this.whyHasTop ? 1 : 0;
            return [this.whyFeatures[o + 2], this.whyFeatures[o + 3]].filter(Boolean);
        },
        whyImage() {
            return normalizeImageUrl(this.highlights && this.highlights.image) || this.images[0] || '';
        }
    },
    methods: {
        openLearnMore(productId) {
            this.currentId = productId;
            this.slide = 0;
            this.openDropdown = null;
            this.futureDate = this.computeFutureDate();
            this.showDialog = true;
            document.body.style.overflow = 'hidden';
        },
        closeModal() {
            this.showDialog = false;
            this.currentId = '';
            document.body.style.overflow = '';
        },
        prevSlide() {
            const n = this.images.length;
            if (n) this.slide = (this.slide - 1 + n) % n;
        },
        nextSlide() {
            const n = this.images.length;
            if (n) this.slide = (this.slide + 1) % n;
        },
        computeFutureDate() {
            const d = new Date();
            d.setDate(d.getDate() + 3);
            const weekday = d.toLocaleDateString('en-US', { weekday: 'short' });
            const month = d.toLocaleDateString('en-US', { month: 'short' });
            const day = d.getDate();
            const suffix = day >= 11 && day <= 13 ? 'th' : (['st', 'nd', 'rd'][(day % 10) - 1] || 'th');
            return `${weekday}, ${month} ${day}<sup>${suffix}</sup>`;
        }
    },
    beforeDestroy() {
        if (this.showDialog) {
            document.body.style.overflow = '';
        }
    }
}
</script>

<style scoped>
.lm, .lm * { font-family: Satoshi, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }

.us-modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.6); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); z-index: 99999999; display: flex; justify-content: center; align-items: center; padding: 16px; }

.lm { position: relative; width: 100%; max-width: 1100px; height: calc(100vh - 80px); max-height: 900px; background: #fff; border-radius: 16px; overflow: hidden; box-shadow: 0 25px 60px rgba(0, 0, 0, 0.3); }

.lm__close { position: absolute; top: 14px; right: 14px; width: 38px; height: 38px; border: none; background: #fff; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 20; transition: background 0.2s, box-shadow 0.2s; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1); }
.lm__close:hover { background: #f5f5f5; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.12); }
.lm__close svg { color: #333; width: 20px; height: 20px; }

.lm__scroll { overflow-y: auto; height: 100%; -webkit-overflow-scrolling: touch; }

.lm__product { padding: 0; }
.lm__product-wrap { max-width: 1280px; margin: 0 auto; padding: 26px 30px 0; }
.lm__product-box { display: flex; gap: 24px; justify-content: center; }

.lm__images { width: 45%; flex-shrink: 0; position: relative; }
.lm__slider { position: relative; margin-bottom: 30px; }
.lm__slide-img { position: relative; width: 100%; aspect-ratio: 1; background: #c9e8ff; overflow: hidden; }
.lm__slide-img img { width: 100%; height: 100%; object-fit: contain; }

.lm__arrow { position: absolute; bottom: 10px; top: auto; transform: none; width: 34px; height: 34px; border-radius: 0; background: transparent; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; z-index: 3; color: #333; }
.lm__arrow:hover { opacity: 0.6; }
.lm__arrow svg { color: #333; width: 28px; height: 28px; }
.lm__arrow--l { left: calc(50% - 60px); }
.lm__arrow--r { right: calc(50% - 60px); }

.lm__thumbs { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 0; }
.lm__thumb { position: relative; width: calc((100% - 18px) / 4); aspect-ratio: 1; background: #fff; border: 1px solid #ccc; border-radius: 10px; overflow: hidden; cursor: pointer; padding: 0; transition: border-color 0.15s; }
.lm__thumb--active { border-color: #000; }
.lm__thumb img { width: 100%; height: 100%; object-fit: contain; }

.lm__detail { width: 55%; flex-shrink: 0; }
.lm__category-label { font-size: 14px; font-weight: 900; color: #000; margin-bottom: 6px; padding: 2px 6px; display: inline-block; }

.lm__rating { display: flex; align-items: center; gap: 6px; margin-bottom: 10px; }
.lm__stars { display: flex; gap: 0; }
.lm__stars svg { flex-shrink: 0; }
.lm__trustpilot-rating { display: flex; align-items: flex-end; gap: 10px; font-size: 14px; }
.lm__tp-excellent { font-weight: 900; color: #000; line-height: 16px; }
.lm__tp-score { color: #333; line-height: 14px; }

.lm__name-box { display: flex; align-items: flex-end; gap: 10px; margin-bottom: 16px; }
.lm__name { font-size: 42px; font-weight: 900; line-height: 42px; color: #000; margin: 0; letter-spacing: 0; }
.lm__brand { font-size: 22px; color: #333; line-height: 22px; }

.lm__divider { height: 0; border: none; border-top: 1px solid #dfdfdf; background: none; margin: 26px 0; }

.lm__desc-header { font-size: 20px; font-weight: 900; line-height: 1.3; color: #333; margin: 0 0 16px; }
.lm__desc { font-size: 14px; line-height: 1.5; color: #333; margin: 0; }

.lm__bullets { display: flex; flex-direction: column; gap: 12px; margin-top: 20px; margin-bottom: 26px; }
.lm__bullet { display: flex; align-items: center; gap: 6px; font-size: 16px; color: #333; }
.lm__bullet-icon { width: 22px; height: 22px; flex-shrink: 0; }

.lm__perks { display: flex; gap: 14px; flex-wrap: wrap; align-items: center; justify-content: center; margin-bottom: 26px; }
.lm__perk { display: flex; align-items: center; gap: 6px; font-size: 14px; color: #333; }
.lm__perk svg { width: 26px; height: 26px; flex-shrink: 0; color: #333; }

.lm__payments { display: flex; flex-direction: column; align-items: center; width: 100%; margin-bottom: 0; }
.lm__payments img { height: 38px; width: 80%; object-fit: contain; margin-bottom: 20px; }

.lm__arrival { display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 14px; font-weight: 500; color: #333; background: #f6f6f6; padding: 16px; border-radius: 10px; width: 80%; margin: 0 auto 6px; }
.lm__arrival sup { font-size: 12px; position: relative; }
.lm__arrival strong { font-weight: 900; }
.lm__arrival-dot { width: 16px; height: 16px; border-radius: 50%; background: #00e600; flex-shrink: 0; }
.lm__delivery-note { font-size: 12px; color: #333; margin-top: 0; margin-bottom: 10px; text-align: center; width: 80%; margin-left: auto; margin-right: auto; }

.lm__dropdowns { display: flex; flex-direction: column; align-items: center; width: 100%; margin-top: 10px; border-top: none; }
.lm__dropdown { width: 80%; border: 1px solid #dfdfdf; margin-bottom: 16px; }
.lm__dropdown-toggle { width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 10px; background: transparent; border: none; cursor: pointer; font-size: 18px; font-weight: 900; color: #222; text-align: left; }
.lm__dropdown-chevron { width: 18px; height: 18px; color: #222; flex-shrink: 0; transition: transform 0.2s; order: 2; margin-left: auto; }
.lm__dropdown-chevron--open { transform: rotate(180deg); }
.lm__dropdown-body { padding: 0 10px 14px; }
.lm__dropdown-body p { font-size: 14px; line-height: 1.6; color: #333; margin: 0; }

.lm__section { padding: 32px 24px; border-top: 1px solid #e5e5e5; }
.lm__section--last { padding-bottom: 40px; }
.lm__section-title { font-size: 30px; font-weight: 900; line-height: 1.15; color: #1a1a1a; margin: 0 0 6px; }
.lm__section-sub { font-size: 14px; color: #888; margin: 0 0 24px; }

.lm__highlights-wrap { max-width: 900px; margin: 0 auto; text-align: center; }
.lm__highlights-text { margin-bottom: 20px; }
.lm__why-grid { max-width: 900px; margin: 0 auto; }
.lm__why-pill { background: #f8f8f8; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px 24px; font-size: 16px; font-weight: 700; color: #1a1a1a; text-align: center; line-height: 1.35; display: flex; align-items: center; justify-content: center; flex: 1; }
.lm__why-pill--top { max-width: 400px; margin: 0 auto 28px; }
.lm__why-middle { display: flex; align-items: center; justify-content: center; gap: 32px; }
.lm__why-col { display: flex; flex-direction: column; gap: 24px; flex: 1; max-width: 300px; }
.lm__why-image { flex-shrink: 0; width: 140px; display: flex; align-items: center; justify-content: center; }
.lm__why-image img { width: 100%; height: auto; max-width: 100%; }
.lm__why-disclaimer { font-size: 13px; color: #6b7280; text-align: center; margin: 28px 0 0; }

.lm__steps { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.lm__step { background: #f8f8f8; border: 1px solid #e5e5e5; border-radius: 12px; padding: 26px 16px 16px; position: relative; overflow: hidden; }
.lm__step-flex { display: flex; align-items: center; gap: 12px; }
.lm__step-img { flex-shrink: 0; width: 90px; height: 90px; border-radius: 10px; overflow: hidden; display: flex; align-items: center; justify-content: center; background: #c9e8ff; }
.lm__step-img img { width: 100%; height: 100%; object-fit: cover; }
.lm__step-text { flex: 1; min-width: 0; }
.lm__step-title { font-size: 15px; font-weight: 900; color: #1a1a1a; line-height: 1.25; }
.lm__step-desc { font-size: 12px; color: #888; margin-top: 3px; line-height: 1.4; }
.lm__step-num { width: 34px; height: 34px; border-radius: 50%; background: #08466f; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: 900; flex-shrink: 0; }
.lm__step-badge { position: absolute; top: 0; right: 0; background: #e9ff86; padding: 3px 10px; font-size: 11px; font-weight: 900; color: #08466f; border-bottom-left-radius: 8px; }

.lm__table-header { font-size: 28px; font-weight: 900; color: #1a1a1a; text-align: center; margin-bottom: 24px; display: flex; align-items: center; justify-content: center; gap: 8px; flex-wrap: wrap; }
.lm__table-logo { height: 22px; width: auto; }
.lm__compare-logo { height: 16px; width: auto; }
.lm__compare { max-width: 800px; margin: 0 auto; }
.lm__compare-head, .lm__compare-row { display: flex; align-items: center; padding: 14px 0; border-bottom: 1px solid #e5e5e5; }
.lm__compare-head { border-bottom: 1px solid #1a1a1a; }
.lm__compare-label { flex: 1; font-size: 14px; color: #333; }
.lm__compare-col { width: 100px; text-align: center; font-size: 14px; font-weight: 600; color: #1a1a1a; flex-shrink: 0; }
.lm__compare-col--muted { color: #999; }
.lm__icon--green { color: #5a8a00; }
.lm__icon--red { color: #ef4444; opacity: 0.4; }

@media (max-width: 1024px) {
    .lm { max-width: 95vw; height: calc(100vh - 60px); max-height: none; }
}

@media (max-width: 768px) {
    .us-modal-overlay { padding: 0; align-items: flex-end; }
    .lm { width: 100%; max-width: 100%; height: calc(100vh - 40px); max-height: none; border-radius: 20px 20px 0 0; }
    .lm__product-wrap { padding: 16px; }
    .lm__product-box { flex-direction: column; gap: 16px; }
    .lm__images { width: 100%; }
    .lm__detail { width: 100%; }
    .lm__name { font-size: 30px; line-height: 30px; }
    .lm__brand { font-size: 18px; }
    .lm__steps { grid-template-columns: 1fr; }
    .lm__compare-label { font-size: 13px; }
    .lm__compare-col { width: 70px; }
    .lm__section-title { font-size: 22px; }
    .lm__table-header { font-size: 22px; }
    .lm__why-middle { gap: 10px; }
    .lm__why-col { gap: 10px; max-width: none; }
    .lm__why-image { width: 90px; }
    .lm__why-pill { padding: 12px 10px; font-size: 13px; border-radius: 10px; }
    .lm__why-pill--top { max-width: 260px; margin-bottom: 16px; }
    .lm__dropdown { width: 100%; }
    .lm__arrival { width: 100%; }
    .lm__delivery-note { width: 100%; }
}
</style>
